import { Typography } from "@mui/material"

type Props = {}

const FriendRequestSentLabel = (props: Props) => {
  return <Typography variant="body1">Request sent!</Typography>
}

export default FriendRequestSentLabel
